import "./index.css";
import "./styles/login.css";
import Routes from "./routes";
import "bootstrap/dist/css/bootstrap.min.css";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";

import { USER_KEY } from "./const";
import MyContext from "./MyContext";
import { useState } from "react";

import { Provider } from "react-redux";
import stores from "./redux/stores";

const httpLink = createHttpLink({
  // uri: "http://localhost:8080/",
  uri: "https://unavsmi5c5.execute-api.ap-southeast-1.amazonaws.com/",   //production
  // uri: "https://pos-api.bbbb.com.la/",   //production
});

const authLink = setContext((_, { headers }) => {
  const localData = localStorage.getItem(USER_KEY);
  let decodeData = JSON.parse(localData);
  return {
    headers: {
      ...headers,
      authorization: decodeData ? decodeData["accessToken"] : "",
    },
  };
});

function App() {
  const [notificationProduct, setNotificationProduct] = useState();
  const [notificationTotal, setNotificationTotal] = useState();
  const client = new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  });
  return (
    <MyContext.Provider
      value={{
        notificationProduct,
        setNotificationProduct,
        notificationTotal,
        setNotificationTotal,
      }}
    >
      <Provider store={stores}>
        <ApolloProvider client={client}>
          <Routes />
          <ToastContainer />
        </ApolloProvider>
      </Provider>
    </MyContext.Provider>
  );
}

export default App;
